import React from 'react';
import {observer} from 'mobx-react'
import Col from '../base-components/Col'
import {generateEventFunctions} from "../../utils/events/actionEventMapper";
import Modal from "../Modal";
import {googleAnalyticsOnClickEvent} from '../../utils/google-analytics-utils';
import { BaseUIComponentProps, replaceBillerInfo } from './BaseUIComponent';
import { IBillerDef, IUIButtonDef } from '../../datatypes';

const {MDBBtn} = require('mdbreact');

interface ButtonProps extends BaseUIComponentProps {
    metadata:IUIButtonDef & {onModalClose:string}; // useless code ???
    onClick:Function[];
}

interface ButtonState {
    loading: boolean,
    showModal: boolean,
    hasModal: boolean,
    onModalClose?: (()=> Promise<any>) [];
}

class Button extends React.Component<ButtonProps,ButtonState> {
  private _isMounted: boolean = false;

  constructor(props:ButtonProps){
    super(props)
    let hasModal = props.metadata.label === 'Add Account'; //TODO: change this. view: cp-schedule-select-account
    let onModalClose:(()=> Promise<any>)[]|undefined;
    if(hasModal && props.metadata.onModalClose) {
        // no such onModalClose predefined event function !!!
      onModalClose = []; //generateEventFunctions(props.metadata.onModalClose, 'onModalClose', props);
    }
    this.state = {
      loading: false,
      showModal: false,
      hasModal: hasModal,
      onModalClose,
    };
  }
  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  replaceBillerInfo(text:string){
    let billerInfo = this.props.formBean.Biller as IBillerDef & {[key:string]:string};
    let regexBiller = /{.*?}/g;
    let allBillerText = text ? text.match(regexBiller) : null;

    if (allBillerText) {
      allBillerText.map(innerText => {
        let attrValue = innerText.replace(/[{}.]|Biller/g,"");
        // TODO: check unknown attr
        text = text.replace(innerText, billerInfo[attrValue] || "")
      });
    }

    return text;
  }
  onClickHandler = async (e:any) => {
    this.setState({loading: true});

    const {metadata} = this.props;
    const {eventTag} = metadata;

    //Check to see if there is an eventTag property for this button
    if(eventTag){
      //if evenTag poperty exists send an OnClick event to Google Analytics with eventTag as the action
      googleAnalyticsOnClickEvent(eventTag);
    }

    try {
      if (this.props.onClick) {
        for (let i = 0; i < this.props.onClick.length; i++) {
            // console.debug(`${this.props.metadata.componentId} call fn ${this.props.onClick[i].name}`)
          //promise.resolve will wait if the handler is async otherwise do it normally
          await Promise.resolve(this.props.onClick[i]());
        }
      }
    } catch (e) {
      console.log(e);
    }
    if(this._isMounted) {
      this.setState({loading: false});
    }
  };
  openModal = (e:any) => {
    this.setState({
      loading: true,
      showModal: true
    })
  }
  onModalClose = async () => {
    this.setState({
      showModal: false
    })
    let onModalClose = this.state.onModalClose;
    if(onModalClose){
      for (let i = 0; i < onModalClose.length; i++) {
        //promise.resolve will wait if the handler is async otherwise do it normally
        await Promise.resolve(onModalClose[i]());
      }
    }
    if(this._isMounted) {
      this.setState({loading: false});
    }
  }

  getExtraProps = (hasModal:boolean) => {
    const {metadata} = this.props;
    let onClickExists = metadata.onClick && metadata.onClick.length > 0;
    let onClick = onClickExists ? (hasModal ? this.openModal : this.onClickHandler.bind(this)) : undefined;
    let href = onClickExists? '' : replaceBillerInfo(metadata.url, this.props.formBean.Biller); // if onClick does not exist, only then fallback to href

    let extraProps = {} as {onClick?:Function, href:string};
    if(onClickExists) extraProps.onClick = onClick;
    if(href) extraProps.href = href;

    return extraProps;
  }

  render() {
    const {metadata, formBean} = this.props;
    const domainAttribute = this.props.domainAttribute!;
    const {
      properties,
      label,
      size,
      cssClasses,
      componentId,
      target
    } = metadata;
  
    let value = label;
    let {xs, sm, md, lg} = properties;
    let btnSize = size;
    let className = cssClasses ? cssClasses : '';
    if(!btnSize) btnSize="sm";

    const {
      loading,
      showModal,
      hasModal
    } = this.state;

    const rendererState = formBean.getRendererState();
    const rendererProps = formBean.getRendererProps();

    //TODO: ???
    let openModalFlow = '';
    if(label === 'Add Account'){
        openModalFlow = 'cp-add-account';
    }

    let extraProps = this.getExtraProps(hasModal);

    return (
      <Col xs={xs} sm={sm} md={md} lg={lg}>
        <MDBBtn color="primary"
                {...extraProps}
                id={domainAttribute.namePrefix + componentId}
                disabled={loading}
                target={target}
                className={className}
                size={btnSize}
        >{value}</MDBBtn>
        {showModal &&
            <Modal onClick={this.onModalClose} domainDataId={rendererState.domainDataId||undefined} flowName={openModalFlow!}
              tla={rendererState.tla!} rendererProps={rendererProps}/>
        }
      </Col>
    )
  }
}

export default observer(Button);